import { makeStyles, Typography } from '@material-ui/core';
import React from 'react';

import MHButton from 'src/components/MHButton';
import { colors } from 'src/themes/colors';

const useStyles = makeStyles({
  welcomeTextBody: {
    flex: 1,
    fontWeight: 100,
    marginBottom: 5,
  },
  welcomeContainer: {
    margin: 30,
    maxWidth: 1300,
    border: `1px solid ${colors.gray1}`,
    borderRadius: 5,
    backgroundColor: '#FFFFFF',
    minWidth: '90%',
    minHeight: 300,
    display: 'flex',
    flexDirection: 'row',
    height: 'fit-content',
    alignItems: 'center',
  },
  lampAndComputer: {
    flex: 0,
    width: 200,
    height: 75,
    justifySelf: 'center',
    margin: 30,
  },
  welcomeTextContainer: {
    flex: 1,
    flexDirection: 'column',
    margin: 30,
    minWidth: 200,
    maxWidth: '40%',
  },
  welcomeTextHeader: {
    flex: 0,
    fontSize: 18,
    fontFamily: 'Avenir-Book',
    fontWeight: 900,
  },
  syncButton: {
    marginTop: 15,
  },
  paragraphText: {
    marginTop: 6,
    marginBottom: 6,
    color: colors.gray8,
  },
});

enum AvailabilityNotSetTestID {
  GetStartedButton = 'AvailabilityNotSetTestID.GetStartedButton',
}

interface Props {
  onGetStartedClick: () => void;
}

export const AvailabilityNotSet: React.FC<Props> = ({ onGetStartedClick }) => {
  const classes = useStyles();

  return (
    <div className={classes.welcomeContainer}>
      <img
        className={classes.lampAndComputer}
        src={require('../../assets/images/lamp-and-computer.png')}
        alt="resource-item"
      />
      <div className={classes.welcomeTextContainer}>
        <Typography className={classes.welcomeTextHeader}>Start connecting with clients</Typography>
        <div className={classes.welcomeTextBody}>
          <Typography className={classes.paragraphText}>
            Link your calendar(s) and set your working hours to get started. Working hours will
            dictate when your linked calendar is checked for open slots. Only open slots will be
            raised for clients to book. Clients can book sessions within 30 days. Once clients have
            booked sessions with you, they will appear below.
          </Typography>
          <MHButton
            extraClasses={[classes.syncButton]}
            onClick={onGetStartedClick}
            data-testid={AvailabilityNotSetTestID.GetStartedButton}
          >
            Get started
          </MHButton>
        </div>
      </div>
    </div>
  );
};
